import RUF from "../../../util/redux";

export function downPaymentSelectionsSave(state, action) {
  return RUF.updateObject(state, {
    model: RUF.updateObject(state.model, {
      downPayment: RUF.updateObject(state.model.downPayment, {
        percent: action.payload
      })
    })
  });
}
